import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
    routeName: {
        home: '首页',
        projectManagement: "项目管理",
        memberManagement: "会员管理",
        memberServices: "会员服务",
        membershipDues: "会费缴纳",
        paymentManagement: "缴费管理",
        excellenceScore: "创优得分",
        realNameEmployManage: "用工实名制管理",
        eventManagement: "活动管理",
        expertManagement: "专家管理",
        personal: "个人中心",
        message: "消息中心",
        download: "下载中心",
        User: '用户管理',
        projectApplication: "项目申报",
        syzj: "市质量水平评价",
        ssfgd: "市示范交流工地",
        gdsyzj: "省施工质量评价",
        gdsyzjgj: "省结构质量评价",
        gdsyzzsj: "省优秀建筑装饰工程",
        gdslssgj: "省绿色施工示范工程奖",
        gdsszsfj: "省市政工程安全文明施工标准化",
        gdsszyzj: "省市政最高质量水平评价",
        gmxmsb: "观摩项目申报",
        sgwfgd: "施工无废工地",
        syzj_member: "市质量水平评价",
        ssfgd_member: "市示范交流工地",
        gdsyzj_member: "省施工质量评价",
        gdsyzjgj_member: "省结构质量评价",
        gdsyzzsj_member: "省优秀建筑装饰工程",
        gdslssgj_member: "省绿色施工示范工程奖",
        gdsszsfj_member: "省市政工程安全文明施工标准化",
        gdsszyzj_member: "省市政最高质量水平评价",
        gmxmsb_member: "观摩项目申报",
        sgwfgd_member: "施工无废工地",
        menu: "菜单管理",
        role: "角色管理",
        configuration: "配置管理",
        speciality: "专家专业配置",
        integral: "会员积分配置",
        memberNature: "会员积分时段配置",
        review: "项目评审项配置",
        excellenceScoreCfg: "创优积分配置",
        excellenceScoreCfg: "创优积分配置",
        ProjectNumber: "会员项目数量配置",
        examine: '评审管理',
        examineList: '评审列表',
        examineDefine: '评审定义',
        memberApplication: "会员管理",
        paymentDeclaration: "缴费申报",
        expert: "首页",
        expertApplication: "专家管理",
        examineProject: "评审项目管理",
        log:"操作日志",
        Template:"导出模板",
    },

    //登录页面
    login: {
        login_title: "东莞市建筑业协会工作系统",
        forget: "忘记密码",
        login: "登录",
        login_foot1: "电话：0769-22658001",
        login_foot2: "传真：22658188",
        login_foot3: "协会邮箱：dgcia@dgcia.com",
        login_foot4: "地址：东莞市万江区共联莲丰贸易市场对面",
        login_foot5: "技术支持：广东筑友信息科技有限公司",
    },
    login_input: {
        userName: "请输入账号",
        password: "请输入密码"
    },
    login_rules: {
        userName: "账号不能为空",
        password: "密码不能为空",
    },
    register: {
        memberRegister: "企业账号注册",
        nMemberRegister: "非会员评优申报",
        expertRegister: "专家申请",
        trainingRegister: "培训报名",
        download: "用户手册下载",
        customerService: "联系客服",
        version: "version:2.3.5",

        //会员注册
        selectMemberType: "选择会员形式",
        localMembers: "本地会员",
        nonLocalMembers: "外地会员",
    },

    //公用
    layout: {
        personalCenter: "个人中心",
        exit: "退出登录",
        close: "关闭",
        closeOther: "关闭其他",
        closeAll: "关闭所有"

    },
    //会员管理页面
    ...zhLocale //  合并element-ui内置翻译
}

export default cn


// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js